'use client';
import BackgroundBlobs from '@/components/BackgroundBlobs';
import LoadingCard from '@/components/LoadingCard';
import { classes } from './utils';

export default function CheckingAuthContainer() {
  return (
    <div className={classes.wrapper}>
      <BackgroundBlobs />
      <LoadingCard message="Checking permissions" />
    </div>
  );
}
